import React, { ReactNode } from "react";
import { createPortal } from "react-dom";

type ModalProps = {
  children: ReactNode;
  isOpen: boolean;
  onClose: () => void;
};

export const Modal = ({ children, isOpen, onClose }: ModalProps) => {
  const baseClassname = "modal";

  const component = isOpen && (
    <>
      <div className="backdrop" onClick={() => onClose()}></div>
      <div className={`${baseClassname}`}>
        <button className={`${baseClassname}__close`} onClick={() => onClose()}>
          X
        </button>
        <div className={`${baseClassname}__content`}>{children}</div>
      </div>
    </>
  );
  return createPortal(component, document.body);
};
